import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
var DEFAULT_COMMAND_TIMEOUT = Number(process.env.REACT_APP_DOBYBOT_COMMAND_TIMEOUT || 3000);
export var DobybotSocketClient = /*#__PURE__*/ function() {
    "use strict";
    function DobybotSocketClient() {
        var port = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : process.env.REACT_APP_DOBYBOT_SOCKET_PORT || 8181;
        _class_call_check(this, DobybotSocketClient);
        this.port = port;
        this.socket = null;
        this.pending = new Map();
    }
    _create_class(DobybotSocketClient, [
        {
            key: "connect",
            value: function connect() {
                var _this = this;
                var _this_socket, _this_socket1;
                if (((_this_socket = this.socket) === null || _this_socket === void 0 ? void 0 : _this_socket.readyState) === WebSocket.OPEN) return Promise.resolve();
                if (((_this_socket1 = this.socket) === null || _this_socket1 === void 0 ? void 0 : _this_socket1.readyState) === WebSocket.CONNECTING) {
                    return new Promise(function(resolve, reject) {
                        _this.socket.addEventListener("open", resolve, {
                            once: true
                        });
                        _this.socket.addEventListener("error", reject, {
                            once: true
                        });
                    });
                }
                return new Promise(function(resolve, reject) {
                    var socket = new WebSocket("ws://localhost:".concat(_this.port));
                    _this.socket = socket;
                    socket.addEventListener("open", resolve, {
                        once: true
                    });
                    socket.addEventListener("error", reject, {
                        once: true
                    });
                    socket.addEventListener("message", function(event) {
                        return _this.handleMessage(event);
                    });
                    socket.addEventListener("close", function() {
                        return _this.clearPending("SOCKET_CLOSED");
                    });
                });
            }
        },
        {
            key: "handleMessage",
            value: function handleMessage(event) {
                var data;
                try {
                    data = JSON.parse(event.data);
                } catch (e) {
                    return;
                }
                var pending = this.pending.get(data.cmd);
                if (!pending) return;
                clearTimeout(pending.timer);
                this.pending.delete(data.cmd);
                pending.resolve(data);
            }
        },
        {
            key: "clearPending",
            value: function clearPending(error) {
                this.pending.forEach(function(param) {
                    var timer = param.timer, resolve = param.resolve;
                    clearTimeout(timer);
                    resolve({
                        success: false,
                        error: error,
                        msg: "การเชื่อมต่อกับ Dobybot ถูกปิด"
                    });
                });
                this.pending.clear();
            }
        },
        {
            key: "send",
            value: function send(command) {
                var _this = this;
                var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this_socket;
                if (((_this_socket = this.socket) === null || _this_socket === void 0 ? void 0 : _this_socket.readyState) !== WebSocket.OPEN) {
                    return Promise.resolve({
                        success: false,
                        error: "SOCKET_NOT_OPEN",
                        msg: "ยังไม่ได้เชื่อมต่อกับ Dobybot Desktop App"
                    });
                }
                var replyCommand = "".concat(command, "/reply");
                if (this.pending.has(replyCommand)) {
                    return Promise.resolve({
                        success: false,
                        error: "COMMAND_PENDING",
                        msg: "มีคำสั่ง Dobybot ประเภทเดียวกันกำลังทำงานอยู่"
                    });
                }
                return new Promise(function(resolve) {
                    var timer = setTimeout(function() {
                        _this.pending.delete(replyCommand);
                        resolve({
                            success: false,
                            error: "COMMAND_TIMEOUT",
                            msg: "Dobybot Desktop App ไม่ตอบกลับภายในเวลาที่กำหนด"
                        });
                    }, DEFAULT_COMMAND_TIMEOUT);
                    _this.pending.set(replyCommand, {
                        resolve: resolve,
                        timer: timer
                    });
                    try {
                        _this.socket.send(JSON.stringify(_object_spread({
                            cmd: command
                        }, payload)));
                    } catch (e) {
                        clearTimeout(timer);
                        _this.pending.delete(replyCommand);
                        resolve({
                            success: false,
                            error: "SEND_FAILED",
                            msg: "ไม่สามารถส่งคำสั่งไปยัง Dobybot Desktop App ได้"
                        });
                    }
                });
            }
        },
        {
            key: "ping",
            value: function ping() {
                return this.send("ping");
            }
        },
        {
            key: "startRecord",
            value: function startRecord(orderNumber) {
                return this.send("start", {
                    order_number: orderNumber
                });
            }
        },
        {
            key: "stopRecord",
            value: function stopRecord() {
                return this.send("stop");
            }
        },
        {
            key: "cancelRecord",
            value: function cancelRecord() {
                return this.send("cancel");
            }
        },
        {
            key: "remark",
            value: function remark(message) {
                return this.send("remark", {
                    msg: message
                });
            }
        },
        {
            key: "close",
            value: function close() {
                var _this_socket;
                this.clearPending("CLIENT_CLOSED");
                (_this_socket = this.socket) === null || _this_socket === void 0 ? void 0 : _this_socket.close();
                this.socket = null;
            }
        }
    ]);
    return DobybotSocketClient;
}();
